import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { bankingPartnerAPI } from '../services/AdminPortal/api';

export const fetchPartnerById = createAsyncThunk(
  'partner/fetchById',
  async (id, thunkAPI) => {
    const response = await bankingPartnerAPI.getById(id);
    if (!response.success) throw new Error(response.message || 'Failed to fetch partner');
    return response.data;
  }
);

const partnerSlice = createSlice({
  name: 'partner',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartnerById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartnerById.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPartnerById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default partnerSlice.reducer; 